export default "__VITE_ASSET__9f5ef48f__"